import React, { Component } from 'react'
import { connect } from 'react-redux'

// Utils
import { translation } from '../../../utils/helpers'

// import components
import Modal from '../../components/Modal'
import Button from '../../elements/button'

import { ModalIcons } from '../../elements/icons'

// Actions
import { enableCarOwnerPortalAccess } from '../../../actions/carownerportal'
import LabelWrapper from '../../elements/labelWrapper'
import Text from '../../elements/text'

class EnableCarOwnerPortalModal extends Component {
  constructor (props) {
    super(props)
    this.state = {
      tabView: 'draft',
      headerTitle: '18152',
      overflowHidden: false,
      CarOwnerPhone: '',
      CarOwnerMail: ''
    }

    this.renderButtonText = this.renderButtonText.bind(this)
    this.redirectToOrder = this.redirectToOrder.bind(this)
    this.onClose = this.onClose.bind(this)
    this.onButtonYesClick = this.onButtonYesClick.bind(this)
    this.onPhoneChange = this.onPhoneChange.bind(this)
    this.onMailChange = this.onMailChange.bind(this)
  }

  renderButtonText (text) {
    if (this.state.forsiIsLoading) {
      return (
        <span className='animated-background'>
          <i className='fa fa-spinner fa-spin fa-x fa-fw' style={{ lineHeight: '13px' }} />
        </span>
      )
    }
    return translation(text)
  }

  redirectToOrder (orderId) {
    this.props.router.push({
      pathname: '/orders/' + orderId,
      state: { createdNew: true }
    })
  }

  onClose (e) {
    // this.redirectToOrder(this.props.orderId)
    e.preventDefault()
    this.props.onCloseCarOwnerMadal()
  }

  onButtonYesClick (e) {
    e.preventDefault()
    this.props.addCarOwnerInformation(this.state.CarOwnerPhone, this.state.CarOwnerMail)
    // let request = {
    //   OrderId: this.props.orderId,
    //   CarOwnerPhone: this.state.CarOwnerPhone,
    //   CarOwnerMail: this.state.CarOwnerMail
    // }
    // this.props.enableCarOwnerPortalAccess(request).then((res) => {
    //   this.redirectToOrder(this.props.orderId)
    // })
  }

  onPhoneChange (e) {
    this.setState({ CarOwnerPhone: e.target.value })
  }

  onMailChange (e) {
    this.setState({ CarOwnerMail: e.target.value })
  }

  render () {
    let modalClass = 'neworder__modal'

    let view = (
      <div>
        <LabelWrapper labelText={translation('18312')} />
        <LabelWrapper labelText={translation('18313')} />
        <Text key='CarOwnerPhone' labelText={translation('14762')} type='text' name='CarOwnerPhone' value={this.state.CarOwnerPhone} onChange={this.onPhoneChange} autoComplete='off' />
        <Text key='CarOwnerMail' labelText={translation('14763')} type='text' name='CarOwnerMail' value={this.state.CarOwnerMail} onChange={this.onMailChange} autoComplete='off' />
        <Button
          labelText={this.renderButtonText('1406')}
          onClick={this.onButtonYesClick}
          style='link'
          disabled={(!this.state.CarOwnerPhone && !this.state.CarOwnerMail)}
        />
      </div>
    )

    return (
      <div className={modalClass}>
        <Modal ref='modal' {...this.props}
          header={translation(this.state.headerTitle)}
          overflowHidden={this.state.overflowHidden}
          clickOutsideClose={false}
          onClose={this.onClose}
          icon={ModalIcons.Quality_Check}
        >
          {view}
        </Modal>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    common: state.common
  }
}

export default connect(mapStateToProps, {
  enableCarOwnerPortalAccess
})(EnableCarOwnerPortalModal)



// WEBPACK FOOTER //
// ./src/app/shared/modals/EnableCarOwnerPortalModal/index.js